import React from 'react';
import { getOrCreateConversation } from 'api/inbox';
import { TConversation } from 'types/inbox';

let globalData: TConversation | undefined = undefined;

const useConversationInfo = (providerId?: number, clientId?: number): [TConversation | undefined, boolean, () => void] => {
    const loading = React.useRef(false);
    const [res, setRes] = React.useState<TConversation | undefined>(globalData);
    const fetchData = async () => {
        if (loading.current) return;
        try {
            loading.current = true;
            const result = await getOrCreateConversation(providerId!, clientId!);
            if (!result.error) {
                const resData = result?.data?.data || undefined;
                globalData = resData;
                setRes(resData);
            }
            // setLoading(false);
        } catch (e) {
            console.error(e);
        }
        loading.current = false;
    };
    React.useEffect(() => {
        if (providerId && clientId) {
            fetchData();
        }
    }, [providerId, clientId]);

    return [res, loading.current, fetchData];
};

export default useConversationInfo;
